import React from "react";
import { Spinner, Alert } from "react-bootstrap";
import { useTranslation } from "react-i18next";

function CartHeader({ isLoading, showAlert, setShowAlert, showAlertEmpty, setShowAlertEmpty }) {
  const { t } = useTranslation();

  return (
    <>
      <h3>{t("cart")}</h3>

      {isLoading && (
        <div className="spinning">
          <Spinner animation="border" role="status">
            <span className="visually-hidden">{t("loading")}</span>
          </Spinner>
        </div>
      )}

      {showAlert && (
        <Alert variant="success" onClose={() => setShowAlert(false)} dismissible>
          {t("order_success")}
        </Alert>
      )}

      {showAlertEmpty && (
        <Alert variant="warning" onClose={() => setShowAlertEmpty(false)} dismissible>
          {t("cart_empty")}
        </Alert>
      )}
    </>
  );
}

export default CartHeader;
